import { Alert } from 'antd';
import { useMemo } from 'react';
import useTranslation from '../localization/useTranslation';
import { translateApiMessages } from '../utilities/translateApiMessage';

const ValidationErrorAlert = ({ messages, onClose, title = 'Validation error' }) => {
  const { language } = useTranslation();
  const translatedMessages = useMemo(
    () => translateApiMessages(messages, language),
    [messages, language],
  );

  if (!translatedMessages?.length) {
    return null;
  }

  return (
    <Alert
      type="error"
      showIcon
      closable
      onClose={onClose}
      message={title}
      description={(
        <ul style={{ margin: 0, paddingInlineStart: 20 }}>
          {translatedMessages.map((msg) => (
            <li key={msg}>{msg}</li>
          ))}
        </ul>
      )}
      style={{ marginBottom: 16 }}
    />
  );
};

export default ValidationErrorAlert;
